import React, { useState } from 'react';
import classNames from 'classnames';

import SectionTextMaybe from './SectionTextMaybe';

import css from './ListingPage.module.css';

/* Short enough to show whole: roughly what three lines hold in the column. */
const SHORT_TEXT_CHARS = 220;

/**
 * The seller's description, three lines until the buyer asks for more
 * (P25009-482 BR-11). The whole text is always rendered — the clamp is CSS —
 * so the server-delivered HTML a crawler reads is unchanged.
 */
const SectionDescriptionClamp = ({ text }) => {
  const [expanded, setExpanded] = useState(false);
  if (!text) return null;

  const lineCount = String(text).split('\n').length;
  const isShort = String(text).length <= SHORT_TEXT_CHARS && lineCount <= 3;

  return (
    <>
      <div
        className={classNames(css.descriptionText, {
          [css.descriptionClamped]: !expanded && !isShort,
        })}
      >
        <SectionTextMaybe text={text} />
      </div>
      {!isShort ? (
        <button
          type="button"
          className={css.descriptionToggle}
          onClick={() => setExpanded(open => !open)}
          aria-expanded={expanded}
        >
          {expanded ? 'Visa mindre' : 'Visa mer'}
        </button>
      ) : null}
    </>
  );
};

export default SectionDescriptionClamp;
